export default __webpack_public_path__ + "static/media/business_show_10.484ac225.png";